const user = {
  namespaced: true,

  state: {
    uid: "",
    email: ""
  },

  mutations: {
    updateUser(state, user) {
      state.uid = user.id;
      state.email = user.email;
    },

    resetUser(state) {
      state.uid = "";
      state.email = "";
    }
  },

  getters: {},

  actions: {
    async signIn({ commit }, user) {
      return commit("updateUser", user);
    },

    updateUser({ commit }, user) {
      return commit("updateUser", user);
    },

    resetUser({ commit }) {
      return commit("resetUser");
    }
  }
};

export default user;
